export function setUser(state, user) {
  state.user = { ...user };
}

export function setState(state, [field, value]) {
  state[field] = value;
}
